import { ProjectService } from '@features/project/project.service';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { ApiService } from '@core/api.service';
import { CrudService } from 'collection';
import { TranslateService } from '@ngx-translate/core';
import { allowLettersNumbersApostropheDashSpace } from '@shared/const/regexp.const';
import { RegexValidator } from '@ui-kit/validation/utility/regExp';
import { Collection } from 'collection';
import { ToasterService } from '@ui-kit/app-toast/toaster.service';

@Component({
  selector: 'create-tag',
  templateUrl: './create-tag.component.html',
  styleUrls: ['./create-tag.component.scss']
})
export class CreateTagComponent implements OnInit {
  tagName = new UntypedFormControl('', [
    Validators.required,
    Validators.maxLength(35),
    RegexValidator(
      allowLettersNumbersApostropheDashSpace,
      this._translate.instant(marker("Please enter a value in the correct format: letters, numbers, ', -, space"))
    )
  ]);
  collection: Collection;

  get nameControlError() {
    const nameControl = this.tagName;
    return nameControl.touched && nameControl.errors;
  }

  private create(): void {
    this.collection.createItem({ data: { name: this.tagName.value } }).subscribe(
      (res) => {
        this.data.subject.next(res.data);
        this._dialogRef.close();
        this._toastService.show({
          type: 'success',
          message: marker('Tag is successfully created')
        });
      },
      (err) => {}
    );
  }

  submit(): void {
    if (this.tagName.valid) {
      this.create();
    } else {
      this.tagName.markAsTouched({ onlySelf: true });
    }
  }

  ngOnInit() {
    this.tagName.valueChanges.subscribe(() => {
      this.tagName.markAsTouched({ onlySelf: true });
    });
  }

  constructor(
    private _elemRef: ElementRef,
    private _api: ApiService,
    private _toastService: ToasterService,
    private _cdr: ChangeDetectorRef,
    private _projectService: ProjectService,
    private _crud: CrudService,
    private _translate: TranslateService,
    public _dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.collection = new Collection({
      api: this._crud.createEntity({ name: 'deviation-tags' })
    });
  }
}
